<div *ngIf="!isLoading" class="favorites-container">
  <ng-container *ngIf="purchasedRecipes?.length">
    <h3 class="favorites-subheader" data-testid="purchased-recipes-title">Purchased</h3>
    <div class="cards-list cards-list--recipes">
      <app-recipe-card
        data-testid="purchased-recipes"
        class="card"
        *ngFor="let recipe of purchasedRecipes"
        [name]="recipe.profile.channel.name"
        [recipe]="recipe"
        [isMyStuff]="true"
      ></app-recipe-card>
    </div>
  </ng-container>

  <div *ngIf="favoriteRecipes?.length && purchasedRecipes?.length" class="separator"></div>

  <ng-container *ngIf="favoriteRecipes?.length">
    <h3 class="favorites-subheader" data-testid="favorite-recipes-title">Favorites</h3>
    <div class="cards-list cards-list--recipes">
      <app-recipe-card
        data-testid="favorite-recipes"
        class="card"
        *ngFor="let recipe of favoriteRecipes"
        [name]="recipe.profile.channel.name"
        [recipe]="recipe"
        [isMyStuff]="true"
      ></app-recipe-card>
    </div>
  </ng-container>

  <ng-container *ngIf="!favoriteRecipes?.length && !purchasedRecipes?.length">
    <div class="empty">
      <img
        src="assets/ui/images/svg/empty-favorites.svg"
        width="130"
        height="130"
        alt="empty-favorites"
      />
      <div class="empty__text">Time to stock up!</div>
      <a class="empty__button" [routerLink]="'/channels'">explore channels</a>
    </div>
  </ng-container>
</div>
